import * as Sentry from "@sentry/react";

import { COOKIE_NAMES, ENVIRONMENTS, safeDecode } from "./shared";

const getCookieValue = (name: COOKIE_NAMES) => {
    const cookies = document.cookie.split("; ");

    for (const cookie of cookies) {
        const [key, value] = cookie.split("=");

        if (key === name) return safeDecode(value);
    }

    return null;
};

Sentry.init({
    dsn: import.meta.env.VITE_SENTRY_DSN,
    beforeSend(event) {
        const isNotLocalEnv =
            import.meta.env.VITE_ENVIRONMENT !== ENVIRONMENTS.Development &&
            import.meta.env.VITE_ENVIRONMENT !==
                ENVIRONMENTS.DevelopmentLocalApi;

        const isConsentGiven =
            getCookieValue(COOKIE_NAMES.Analytics) === "true";

        return isNotLocalEnv && isConsentGiven ? event : null;
    },
    // set in CI/CD docker image build job
    release: import.meta.env.VITE_SENTRY_RELEASE,
    environment: import.meta.env.VITE_ENVIRONMENT
});
